<div class="getting-started-page-container">
<div class="getting-started-content">
  <div class="getting-started-heading">
    <p class="main-heading">Welcome to {{ tenantName }}</p>
    <p>{{pageQuote}}</p>
  </div>
  <div class="major-attractions">
    <div *ngFor="let item of showMainAttractionsData" class="major-attractions-item">
      <ng-container [ngSwitch]="item.link">
       <ng-container *ngIf="icons[item.link]">
        <div class="icon-container" [innerHTML]="icons[item.link]"></div>
       </ng-container>
       <ng-container *ngIf="!icons[item.link]">
        <div class="no-icon"></div>
       </ng-container>
      </ng-container>
      <p class="major-attractions-text">{{ item.title }}</p>
    </div>
  </div>
  <div class="button">
    <button class="p-button l-form-button l-body-bold" (click)="this.next.emit()">{{continueText}}</button>
  </div>
  <ng-content></ng-content>
</div>
</div>
